import { render, staticRenderFns } from "./PsiFormHiddenField.vue?vue&type=template&id=47e7c210&"
import script from "./PsiFormHiddenField.vue?vue&type=script&lang=js&"
export * from "./PsiFormHiddenField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports